/**
 * Collection View Toggle
 * Handles switching between grid and list view for product collections
 */
(function() {
  'use strict';

  function initCollectionViewToggle() {
    const productGrid = document.getElementById('product-grid');
    const viewButtons = document.querySelectorAll('.facets__view-btn[data-view]');
    
    if (!productGrid || viewButtons.length === 0) return;

    // Get saved view preference or default to grid
    const currentView = localStorage.getItem('collection-view') || 'grid';

    function setView(view) {
      if (!productGrid) return;

      // Update grid data attribute
      productGrid.setAttribute('data-view', view);

      // Update button states
      viewButtons.forEach(button => {
        if (button.dataset.view === view) {
          button.classList.add('active');
        } else {
          button.classList.remove('active');
        }
      });

      // Add view class to product grid container
      const container = productGrid.closest('.product-grid-container');
      if (container) {
        container.classList.remove('view-grid', 'view-list');
        container.classList.add(`view-${view}`);
      }
    }

    // Set initial view
    setView(currentView);

    // Add click handlers to view buttons
    viewButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        const view = e.currentTarget.dataset.view;
        setView(view);
        localStorage.setItem('collection-view', view);
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionViewToggle);
  } else {
    initCollectionViewToggle();
  }

  // Re-initialize after AJAX updates (facets.js updates)
  document.addEventListener('facet:updated', initCollectionViewToggle);
})();

